module.exports = __webpack_public_path__ + "thumbsUp.3671860f.png";